export const TYPE = 'arrow-head';

const ArrowHead = fabric.util.createClass(fabric.Triangle, {
  type: TYPE,

  initialize: function (options: fabric.ITriangleOptions) {
    const defaults: fabric.ITriangleOptions = {
      id: TYPE,
      originX: 'center',
      width: 10,
      height: 10,
      fill: 'black',
      opacity: 0.5,
      angle: 0,
    } as fabric.ITriangleOptions;

    this.callSuper('initialize', { ...defaults, ...options });
  },

  toObject: function () {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      id: this.id,
    });
  },
});

ArrowHead.fromObject = function (object: fabric.Object, callback: (obj: fabric.Object) => void) {
  const arrowHead = new ArrowHead(object);
  if (callback) callback(arrowHead);
  return arrowHead;
};

export default ArrowHead;
